angular.module('app.controllers.non-paginated-forms.information-request', [])
    .controller("InformationRequestController", function ($scope, $window, $http, appConstants) {
        $scope.aversion = appConstants.version;
        $scope.form_processed = "";
        $scope.form_name = "Information Request";
        // $scope.caprequired = true;
        $scope.caprequired = appConstants.captchaRequired; // localhost = false otherwise true
        $scope.allowedChars = /^[A-z0-9-'.,\!\+\(\)\/ ]+$/;
        $scope.addressChars = /^[A-z0-9-'.,\!\+\(\)\/\# ]+$/;
        $scope.onlyNumbers = /^([0-9]*)$/;
        $scope.validEmail = /^([\w-+\!\#\$\%\&]+(?:\.[\w-+\!\#\$\%\&]+)*)@((?:[A-z0-9-)]+\.)*\w[A-z0-9-]{0,66})\.([A-z0-9-]{2,8}(?:\.[A-z0-9-]{8})?)$/i;
        $scope.form_info = [
            "If you have an emergency, please do not use this form. Call 877-860-6020 if you have an" +
            " emergency or safety related issue."
        ];
        $scope.success_response = [
            "All printed materials will be delivered by U.S. Postal Service.",
            "If you have an emergency, call your local Southwest Gas office immediately. Do not use this form to notify us of an emergency situation.",
            "Thank you for using the Shareholder Services On-Line Information Request Form.",
            "You will receive the information you requested within 7 business days.",
            "If you do receive your information after 7 business days,",
            "please contact Southwest Gas Corporate Shareholder Services."
        ];

        $window.setCapRequired = function (value) {
            $scope.caprequired = value;
            $scope.$digest();
            //   alert(value);
        };

        $scope.resetForm = function () {
            //alert($scope.resetForm);
            $scope.currentAnnualReport = "";
            $scope.formTenQ = "";
            $scope.earningsNewsRelease = "";
            $scope.currentProxyStatement = "";
            $scope.firstname = "";
            $scope.middleinitial = "";
            $scope.lastname = "";
            $scope.title = "";
            $scope.organization = "";
            $scope.city = "";
            $scope.addresslineone = "";
            $scope.addresslinetwo = "";
            $scope.state = "";
            $scope.zipcode = "";
            $scope.preferspdfformatemail = "";
            $scope.homephonenum = "";
            $scope.faxphonenum = "";
            $scope.workphonenum = "";
            $scope.email = "";
            $scope.investortype = "";
            $scope.workphoneext = "";
            $('html,body').scrollTop(0);
        };
        $scope.resetForm();

        $scope.submit = function () {
            if ($scope.form_processed === "") {
                $scope.form_processed = "Processing . . .";
                var currentAnnualReport = $scope.currentAnnualReport,
                    formTenQ = $scope.formTenQ,
                    earningsNewsRelease = $scope.earningsNewsRelease,
                    currentProxyStatement = $scope.currentProxyStatement,
                    first = $scope.firstname,
                    middleinitial = $scope.middleinitial,
                    last = $scope.lastname,
                    title = $scope.title,
                    organization = $scope.organization,
                    city = $scope.city,
                    addressLineOne = $scope.addresslineone,
                    addressLineTwo = $scope.addresslinetwo,
                    state = $scope.state,
                    zip = $scope.zipcode,
                    prefersPdfFormatEmail = $scope.preferspdfformatemail,
                    homePhone = $scope.homephonenum,
                    faxPhone = $scope.faxphonenum,
                    workPhone = $scope.workphonenum,
                    email = $scope.email,
                    investor = $scope.investortype,
                    workPhoneExt = $scope.workphoneext;

                $.ajax({
                    url: "/swgasws/resources/form/informationrequest/addRequest",
                    type: "post",
                    dataType: 'json',
                    data: {
                        currentAnnualReport: $scope.currentAnnualReport,
                        formTenQ: formTenQ,
                        earningsNewsRelease: earningsNewsRelease,
                        currentProxyStatement: currentProxyStatement,
                        first: first,
                        middleinitial: middleinitial,
                        title: title,
                        last: last,
                        organization: organization,
                        addressLineOne: addressLineOne.replace(/#/g, ":"),
                        addressLineTwo: addressLineTwo.replace(/#/g, ":"),
                        state: state,
                        city: city,
                        zip: zip,
                        prefersPdfFormatEmail: prefersPdfFormatEmail,
                        email: email,
                        homePhone: homePhone,
                        faxPhone: faxPhone,
                        workPhone: workPhone,
                        investor: investor,
                        workPhoneExt: workPhoneExt,
                        gRecaptchaResponse: grecaptcha.getResponse()
                    },
                    success: function (data) {

                        switch (data.status) {
                            case 'success':
                                document.getElementById("responsemessage").innerHTML = "<p><span class='form-sub-good'>" + data.message + "</span> </p><p>All printed materials will be delivered by U.S. Postal Service.</p><p>If you have an emergency, call your local Southwest Gas office immediately. Do not use this form to notify us of an emergency situation.</p><p><br />Thank you for using the Shareholder Services On-Line Information Request Form.</p><p>You will receive the information you requested within 7 business days.</p><p>If you do receive your information after 7 business days,<br />please contact Southwest Gas Corporate Shareholder Services.</p>";
                                break;
                            case 'badrequest':
                                resp = data.toString().split("|");
                                document.getElementById("responsemessage").innerHTML = "<p><span class='form-sub-error'>" + data.message + " Please try again later.  The Webmaster has been notified of the submission problem(s). <br /> " + resp[1] + "</span></p>";
                                break;
                            case 'error':
                                document.getElementById("responsemessage").innerHTML = "<p><span class='form-sub-error'>" + data.message + " The Webmaster has been notified of the submission problem(s). <br /> </span></p>";
                                break;
                            default:  // all other errors
                                document.getElementById("responsemessage").innerHTML = "<p><span class='form-sub-error'>" + data.message + " The Webmaster has been notified about this problem.</span></p>";

                        }  // end switch

                        $scope.isDisabled = !0;
                        $scope.resetForm();
                        $scope.defaultForm.$setPristine();
                    },
                    error: function (response) {
                        document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-error'>Your Shareholder Services Information Request inquiry has NOT been sent due to maintenance.  We apologize for the inconvenience at this time. Please try again later.</span></p>";
                        $scope.resetForm();
                        $scope.defaultForm.$setPristine();
                    }
                });
            }
        };
    });
